import React, { useState } from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';

const StyledListItemIcon = styled(ListItemIcon)`
  min-width: 35px;
`;

const AccordionSection = ({ title, icon, items }) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Accordion expanded={expanded} onChange={handleExpandClick}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls={`${title}-content`}
        id={`${title}-header`}
      >
        <StyledListItemIcon>
          {icon}
        </StyledListItemIcon>
        <ListItemText primary={title} />
      </AccordionSummary>
      <AccordionDetails>
        <List>
          {items.map((item, index) => (
            <ListItem component={Link} to={item.link} key={index}>
              <StyledListItemIcon>
                {item.icon}
              </StyledListItemIcon>
              <ListItemText primary={item.text} />
            </ListItem>
          ))}
        </List>
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionSection;
